<template>
  <v-container data-app fluid class="v-application container-page full-width">
    <MultiSplitPane
      split="horizontal"
      height=""
      resizerWidth="5px"
      classes="custom-resizer"
    >
      <Pane id="panel-left" :initWidth="'100%'">
        <template v-slot:content>
          <div
            class="width100 d-flex v-middle text-title-container justify-space-between p-l-0 p-r-0"
          >
            <div class="text-title text-primary">{{ titleName }}</div>
            <div class="d-flex v-middle m-r-5">
              <VueCtkDateTimePicker
                v-model="search.from"
                :max-date="search.to"
                :format="$datetimeFormatDefault"
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                class="start width150px m-l-10"
              >
                <v-text-field
                  class="font-size-body"
                  v-model="dateFrom"
                  prepend-inner-icon="mdi-calendar small"
                  label="From"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </VueCtkDateTimePicker>
              <VueCtkDateTimePicker
                v-model="search.to"
                :min-date="search.from"
                :format="$datetimeFormatDefault"
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                class="end width150px m-l-10"
              >
                <v-text-field
                  class="font-size-body"
                  v-model="dateTo"
                  prepend-inner-icon="mdi-calendar small"
                  label="to"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </VueCtkDateTimePicker>
              <v-autocomplete
                id="select-email"
                v-model="search.api"
                label="API"
                :items="apis"
                item-text="label"
                item-value="value"
                item
                clearable
                clear-icon="fa-times"
                dense
                hide-details
                :menu-props="{
                  bottom: true,
                  offsetY: true,
                  contentClass: 'autocomplete-menu-280px'
                }"
                class="m-l-10 width200px"
              ></v-autocomplete>
              <v-autocomplete
                id="select-email"
                v-model="search.statusCode"
                label="Status"
                :items="statusCodes"
                item-text="label"
                item-value="value"
                item
                clearable
                clear-icon="fa-times"
                dense
                hide-details
                :menu-props="{
                  bottom: true,
                  offsetY: true,
                  contentClass: 'autocomplete-menu-280px'
                }"
                class="m-l-10 width200px"
              ></v-autocomplete>
              <v-menu :absolute="true">
                <template v-slot:activator="{ on }">
                  <v-icon id="icon-dots" class="p-l-10 p-r-5" v-on="on">
                    fa-ellipsis-v
                  </v-icon>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="(option, index) in options"
                    :key="index"
                    :class="option.divider ? 'menu-divider' : ''"
                  >
                    <v-list-item-content v-if="option.divider">
                      <hr />
                    </v-list-item-content>
                    <v-list-item-content
                      v-else
                      class="pointer"
                      @click="optionClick(option.action)"
                    >
                      <v-list-item-subtitle
                        :id="`list${index}`"
                        class="font-size-body"
                        >{{ option.title }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="apiLogs"
            :page.sync="search.page"
            :sort-by.sync="search.sortBy"
            :sort-desc.sync="search.sortDesc"
            :items-per-page="9999"
            hide-default-footer
            fixed-header
            must-sort
            class="elevation-1"
          >
            <template v-slot:item="props">
              <tr
                :id="`row-click${apiLogs.indexOf(props.item)}`"
                v-on:click="rowClick(props.item)"
                :class="
                  indexRow === apiLogs.indexOf(props.item) ? 'row-active' : ''
                "
              >
                <td class="cursor-pointer">
                  {{ props.item.created_at | datetimeFormat }}
                </td>
                <td class="cursor-pointer">{{ props.item.method }}</td>
                <td class="cursor-pointer">{{ props.item.url }}</td>
                <td class="cursor-pointer">{{ props.item.status_code }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-row
            v-if="apiLogs.length > 0"
            class="fix-height mr-0 ml-0"
            align="center"
            justify="end"
          >
            <v-col
              class="d-flex align-center padding0 pagination"
              cols="auto"
              sm="auto"
              md="auto"
              lg="auto"
            >
              Page size
              <v-select
                id="perpage"
                class="select-item text-center m-l-10 m-r-10"
                v-model="search.limit"
                :items="$itemspage"
                item-text="title"
                item-value="value"
                no-label
                hide-details
                dense
                @input="search.limit = parseInt($event, 10)"
              ></v-select>
              Showing {{ (search.page - 1) * search.limit + 1 }} -
              {{ (search.page - 1) * search.limit + apiLogs.length }}
              of
              {{ total | decimalFormat }}

              <v-pagination
                id="pagination"
                v-model="search.page"
                :length="totalPage"
                :total-visible="totalVisible"
                @input="next"
              ></v-pagination>
            </v-col>
          </v-row>
        </template>
      </Pane>
      <Pane id="panel-right" :initWidth="'0%'">
        <template v-slot:content>
          <detail :apiLogDetail="apiLogDetail" />
        </template>
      </Pane>
    </MultiSplitPane>
  </v-container>
</template>

<script>
import Moment from 'moment'

import { MultiSplitPane, Pane } from 'vue-multi-split-pane'

import apiApiLog from '@/apis/api_log'
import csvExporter from '@/services/campaign/csv'

import Detail from './components/detail'

export default {
  components: {
    Detail,
    MultiSplitPane,
    Pane
  },
  data() {
    return {
      options: [{ title: 'Download API log', action: 'download_api_log' }],

      loading: false,
      format: 'YYYY-MM-DD HH:mm',
      search: {
        api: '',
        statusCode: '',
        from: '',
        to: '',
        sortBy: ['created_at'],
        sortDesc: ['desc'],
        page: 1,
        limit: 50
      },
      statusCodes: [],
      apis: [],
      headers: [
        {
          text: 'Timestamp',
          sortable: true,
          value: 'created_at',
          width: '30%'
        },
        { text: 'Method', sortable: true, value: 'method', width: '15%' },
        { text: 'URL', sortable: true, value: 'url', width: '40%' },
        { text: 'Status', sortable: true, value: 'status', width: '15%' }
      ],
      total: 0,
      totalPage: 1,
      totalVisible: 7,
      apiLogs: [],
      indexRow: -1,
      apiLogDetail: {
        id: '',
        currentTab: -1
      },
      titleName: process.env.VUE_APP_CUSTOMIZE_API_LOG || 'API log'
    }
  },
  computed: {
    dateFrom() {
      return this.$options.filters.convertDatetimePicker(this.search.from)
    },
    dateTo() {
      return this.$options.filters.convertDatetimePicker(this.search.to)
    }
  },
  created() {
    const title = this.$t('page-title.api_log', {
      productName: this.$options.filters.getVariable('product_name')
    })
    document.title = process.env.VUE_APP_CUSTOMIZE_API_LOG
      ? title.replace(/API log/g, process.env.VUE_APP_CUSTOMIZE_API_LOG)
      : title

    this.search.from = Moment()
      .startOf('day')
      .format(this.format)
    this.search.to = Moment()
      .startOf('day')
      .add(1, 'days')
      .format(this.format)

    this.initial()

    for (const property in this.search) {
      this.$watch(
        `search.${property}`, //what you want to watch
        (newVal, oldVal) => {
          if (
            this.search.sortBy.length === 0 ||
            this.search.sortDesc.length === 0
          )
            return
          this.getApiLog(property)
        }
      )
    }
  },
  methods: {
    next(page) {
      this.indexRow = -1
    },
    async initial() {
      await this.getDataFilter()
      await this.getApiLog()
    },
    async getDataFilter() {
      try {
        const getFilter = await apiApiLog.getDataFilter()

        const { data } = getFilter
        this.apis = data.apis
        this.statusCodes = data.status_codes
      } catch (error) {}
    },
    async optionClick(action) {
      switch (action) {
        case 'download_api_log':
          const { api, statusCode, from, to } = this.search

          const obj = {
            api,
            statusCode,
            from,
            to
          }

          const getCSV = await apiApiLog.getCSV(obj)

          await csvExporter.exporter(getCSV.data, 'API log')

          break
        default:
          break
      }
    },
    async getApiLog(property) {
      try {
        if (!['sortBy', 'sortDesc', 'page'].includes(property))
          this.search.page = 1

        this.loading = true

        const getApiLog = await apiApiLog.getApiLog(this.search)
        const { docs, totalPages, totalDocs } = getApiLog.data
        this.totalPage = totalPages
        this.total = totalDocs

        const apiLogs = []
        for (let i = 0; i < docs.length; i++) {
          const obj = {}
          obj._id = docs[i]._id || ''
          obj.created_at = docs[i].created_at
          obj.method = docs[i].method
          obj.url = docs[i].url
          obj.status_code = docs[i].status_code

          apiLogs.push(obj)
        }

        this.apiLogs = apiLogs

        setTimeout(() => {
          this.loading = false
        }, 500)
        return res
      } catch {}
    },
    rowClick(data) {
      this.indexRow = this.apiLogs.indexOf(data)
      this.apiLogDetail.id = data._id

      setTimeout(() => {
        const panelRight = document.getElementById('panel-right')
        if (panelRight.offsetWidth < 650) {
          panelRight.style.width = '650px'
        }
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-resizer {
  height: calc(100vh - 75px) !important;

  #panel-left {
    min-width: 870px;
  }
}
#icon-dots {
  margin-top: auto;
  margin-left: 10px;
  font-size: 22px !important;
}
.pointer {
  cursor: pointer;
}

::v-deep .v-data-table__wrapper {
  height: calc(100vh - 180px);
}

.width150px {
  width: 150px;
  min-width: 150px;

  .v-input {
    margin-bottom: -8px;
  }
}

.width200px {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  margin-top: 12px;
}

.select-item {
  max-width: 70px !important;
}
::v-deep .select-item .v-select__selection {
  color: #727272 !important;
}

::v-deep .end .datepicker {
  right: 0;
}

::v-deep .v-list-item__title {
  white-space: pre-line !important;
}
</style>
